import { cartLineQuantityStyles as styles } from "@bevco/Overrides/Widgets/Cart/CartLineQuantity";

// Verndale Customization: Styles for unit of measure
styles.readOnlyQuantityText = {
    heading: {
        variant: "legend",
        size: 12,
        transform: "uppercase",
    },
    text: {
        mergeCss: true,
        variant: "p",
        size: 14,
        transform: "uppercase",
        weight: 400,
    },
};
